// src/constants/audio.js
export const VOICE_MODELS = [
  {
    id: '54c4c9b7208c41ba9506e28ce058176f',
    name: 'Emma Wilson',
    previewUrl: 'voices/8654dd73ca1440fd8f6eefbe329d0f85.mp3',
    theme: 'from-pink-500 to-rose-500'
  },
  {
    id: 'd2b865ab21604f6287de11e462213bd4',
    name: 'Michael Reed',
    previewUrl: 'voices/4b34a9ec2a7f407cac8750f196d0bc59.mp3',
    theme: 'from-blue-500 to-indigo-500'
  },
  {
    id: '53ad1fcfdc2f4a98ab3aef70d1d5029e',
    name: 'Sarah Anderson',
    previewUrl: 'voices/0b845163ce614d588fa2ed7915ae23e4.mp3',
    theme: 'from-pink-500 to-rose-500'
  },
  {
    id: 'd8c7af3779494549a975bdb8015e8a8b',
    name: 'John Davis',
    previewUrl: 'voices/547ef4443af84739a4586ff0bc42594c.mp3',
    theme: 'from-blue-500 to-indigo-500'
  },
  {
    id: '58239adce1eb426883dd74fc9a7c8074',
    name: 'Jennifer Parker',
    previewUrl: 'voices/27d21f9ce11d47eea7db6019a9b31e4e.mp3',
    theme: 'from-pink-500 to-rose-500'
  },
];

export const BACKGROUND_MUSIC = [
  { 
    id: '7a8b9c12-3d4e-5f6a-7b8c-9d0e1f2a3b4c', 
    name: 'Deep Focus', 
    description: 'Gentle waves with soft synthesizer',
    previewUrl: 'music/7a8b9c12-3d4e-5f6a-7b8c-9d0e1f2a3b4c.mp3',
    theme: 'from-blue-500 to-indigo-500'
  },
  { 
    id: '2c3d4e5f-6a7b-8c9d-0e1f-2a3b4c5d6e7f', 
    name: 'Meditation Flow', 
    description: 'Soft binaural beats with crystal bowls',
    previewUrl: 'music/2c3d4e5f-6a7b-8c9d-0e1f-2a3b4c5d6e7f.mp3',
    theme: 'from-purple-500 to-pink-500'
  },
  { 
    id: '3f6f93c1-5f98-4c24-b06e-ed2f86c5940a', 
    name: 'Calming Nature', 
    description: 'Peaceful sounds of nature with gentle piano',
    previewUrl: 'music/3f6f93c1-5f98-4c24-b06e-ed2f86c5940a.mp3',
    theme: 'from-emerald-500 to-teal-500'
  },
];